import { Outlet } from "react-router-dom";
import MarketplaceNav from "../../components/navigation/MarketplaceNav";

interface Props {
    guideOpened: any
    setGuideOpened: any
}

export default function FindACoachLayout(props: Props) {
    return (
        <>
            <MarketplaceNav
                guideOpened={props.guideOpened}
                setGuideOpened={props.setGuideOpened}
            />
            <Outlet />
        </>
    )
}